import React from 'react';

const BADGE_CLASS = {
  admin: 'badge-primary',
  vendor: 'badge-warning',
  platform: 'badge-secondary',
  platform_cms: 'badge-info',
  customer: 'badge-light',
  seed: 'badge-secondary',
  user: 'badge-light',
  unknown: 'badge-secondary',
};

export default function CreatorBadge({ type, label }) {
  if (!label) return null;
  const cls = BADGE_CLASS[type] || 'badge-secondary';
  return <span className={`badge ${cls} ml-1`} title="Who created this record">{label}</span>;
}
